import { Organization } from "./Organization";
import { User } from "./User";

export class OrganizationInvitation {
    id: string = "";
    email: string = "";
    createdAt: Date | null = null;
    organizationId: string | null = null;
    organization: Organization | null = null;
    createdByUser: User | null = null;

    constructor(init?: Partial<OrganizationInvitation>) {
        if (!init) {
            return;
        }

        Object.assign(this, init);

        if (init.organization) {
            this.organization = new Organization(init.organization);
        }

        if (init.createdByUser) {
            this.createdByUser = new User(init.createdByUser);
        }
    }
}
